import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form';
import { ControlledRadioGroup, ControlledTextField } from '../../../../shared/components';
import {
  MUNICIPAL_COUNCIL,
  MUNICIPAL_COUNCIL_OPTIONS,
  SANCTIONING_AUTHORITY_BASIC_OPTIONS,
  SANCTIONING_AUTHORITY_TOWN_PLANNING_OPTION,
  SANCTIONING_AUTHORITY_TYPE,
} from '../../../domain/work.constants';

export default function SanctioningAuthoritySection() {
  const { watch } = useFormContext();
  const type = watch('details.sanctioningAuthority.type');
  const taluka = watch('details.sanctioningAuthority.taluka');

  return (
    <div className='column gap-1'>
      <div className='column gap-1'>
        <ControlledRadioGroup
          name='details.sanctioningAuthority.type'
          orientation='column'
          label='Sanctioning Authority'
          options={SANCTIONING_AUTHORITY_BASIC_OPTIONS}
          wrapperSx={{ '& label': { alignSelf: 'flex-start' } }}
          sx={{ gap: 1, pl: 1 }}
        />

        <div className='row gap-3 indent-1'>
          <ControlledRadioGroup
            name='details.sanctioningAuthority.type'
            orientation='column'
            options={SANCTIONING_AUTHORITY_TOWN_PLANNING_OPTION}
            wrapperSx={{ gap: 1, width: 'fit-content' }}
          />

          {type === SANCTIONING_AUTHORITY_TYPE.TOWN_PLANNING && (
            <ControlledTextField
              name='details.sanctioningAuthority.townPlanningOffice'
              placeholder='Specify '
              rules={{
                validate: (value, formValues) =>
                  formValues.details.sanctioningAuthority.type !==
                    SANCTIONING_AUTHORITY_TYPE.TOWN_PLANNING ||
                  Boolean(value?.trim()) ||
                  'Required when Town Planning is selected',
              }}
              sx={{ maxWidth: 240 }}
            />
          )}
        </div>

        <div className='row gap-3 items-start indent-1'>
          <ControlledRadioGroup
            name='details.sanctioningAuthority.type'
            orientation='column'
            options={[
              {
                label: 'Municipal Council',
                value: SANCTIONING_AUTHORITY_TYPE.MUNICIPAL,
              },
            ]}
            wrapperSx={{ gap: 1, width: 'fit-content' }}
            sx={{ alignSelf: 'flex-start' }}
          />

          {type === SANCTIONING_AUTHORITY_TYPE.MUNICIPAL && (
            <Stack gap={1}>
              <Typography variant='body2' color='grey.500'>
                Select Taluka
              </Typography>
              <Stack
                spacing={1}
                sx={{
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  padding: 1,
                  maxHeight: 180,
                  overflowY: 'auto',
                  minWidth: 260,
                }}
              >
                <ControlledRadioGroup
                  name='details.sanctioningAuthority.taluka'
                  orientation='column'
                  options={MUNICIPAL_COUNCIL_OPTIONS}
                  sx={{ gap: 1 }}
                />

                <div className='row gap-3'>
                  <ControlledRadioGroup
                    name='details.sanctioningAuthority.taluka'
                    orientation='column'
                    options={[{ label: 'Other', value: MUNICIPAL_COUNCIL.OTHER }]}
                  />

                  <ControlledTextField
                    name='details.sanctioningAuthority.talukaOtherText'
                    placeholder='Specify'
                    sx={{ width: 240 }}
                    disabled={taluka !== MUNICIPAL_COUNCIL.OTHER}
                  />
                </div>
              </Stack>
            </Stack>
          )}
        </div>
      </div>
    </div>
  );
}
